
import { Injectable, enableProdMode } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({ providedIn: 'root' })// singelton
export class ConfigService {

  public _serverUrl: string;

  constructor(private http: HttpClient)
  {
   
  }

  loadAppConfig() {
    const self = this;
    return this.http.get('/assets/config.json')
      .toPromise()
      .then(data => {
        
        self._serverUrl = data['serviceURL'];
        console.debug('Service address is: ' + self._serverUrl);
      });
  }
}

export interface Config {
  serviceURL: string;
  
}
